import { globalRef } from '@amazon/vinyl-util'
import { errorMessage } from '@/util/errorUtil'
import { type ErrorReport } from '@/errorHandler'

export interface LastError {
    readonly message: string
    readonly stack: string | null
    readonly timestamp: number
}

// Most-recent error routed through `handleError`. Lives in this tiny
// main-chunk module (not in `help/collectDiagnostics`) so bootstrap can wire
// `onError(setLastError)` without pulling the lazy Help chunk into the main
// bundle; the bug-report diagnostics collector reads it back via
// `getLastError()`. Captures pre-help-open crashes so a user filing a bug
// attaches the crash they just saw without copy-pasting from DevTools.
const lastErrorRef = globalRef<{ error: LastError | null }>(() => ({ error: null }))

export function setLastError(report: ErrorReport): void {
    const { error } = report
    lastErrorRef.value.error = {
        message: errorMessage(error),
        stack: error instanceof Error && typeof error.stack === 'string' ? error.stack : null,
        timestamp: Date.now(),
    }
}

/** Returns the most recent non-silent error, or `null`. */
export function getLastError(): LastError | null {
    return lastErrorRef.value.error
}
